import { render, staticRenderFns } from "./user-field.vue?vue&type=template&id=1f64b541&lang=pug"
import script from "./user-field.vue?vue&type=script&lang=js"
export * from "./user-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports